var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatus1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40V43M22.5 35V36.5C22.498 37.501 23.494 38.16 24.298 38.655L30.718 42.627C31.511 43.124 32.707 43.497 33.5 43L39.702 38.655C40.506 38.159 41.502 37.001 41.5 36V35H22.5Z",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.495 35L22.505 29",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 35V29",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 33V40",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.009L31 31.5C31.828 31.996 32.503 32.124 33.33 31.628L41 27",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32V34M36 24.5L29.325 28.247C28.508 28.699 27.503 29.59 27.5 30.5V34L36 24.5Z",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 30V29C41.51 27.975 41.302 27.012 40.5 26.5L33.5 22C33.1 21.745 32.446 21.497 32 21.5C31.564 21.503 30.891 21.751 30.5 22L23.5 26.5C22.694 27.066 22.505 27.475 22.5 28.5V30",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 47.498L13.72 54.488C13.095 55.171 12.093 55.171 11.466 54.488C10.845 53.796 10.845 52.674 11.466 51.982L17.754 45",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21C40.7 21.779 42.893 23.606 44 26",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49.5C43.2173 49.5 51.5 41.2173 51.5 31C51.5 20.7827 43.2173 12.5 33 12.5C22.7827 12.5 14.5 20.7827 14.5 31C14.5 41.2173 22.7827 49.5 33 49.5Z",
    stroke: "#E1C078",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.5C14.5 41.5 22.5 49.5 33.5 49.5",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus1);
export default __webpack_public_path__ + "static/media/status 1.f440386b5cc3aea03e03ae5f88ca0894.svg";
export { ForwardRef as ReactComponent };